<template>
  <NuxtLayout name="catalog">
    <div class="page-container mb-8">
      <MoleculesGlobalBreadcrumb class="my-6" :segments="[{ url: usePage().value.page?.url, name: $t('Konfigurátor snubních prstenů') }]" />
      <AtomsTextHeader :type="1" class="header--with-line">{{ $t('Konfigurátor snubních prstenů') }}</AtomsTextHeader>
      <div class="flex flex-wrap gap-6">
        <div>
          <strong class="block mb-2 uppercase">{{ $t('Velikost dámského prstenu') }}:</strong>
          <Multiselect :close-on-select="true" :canClear="false" :canDeselect="false" :options="womenSizes" :placeholder="$t('vyberte...')" label="name" valueProp="id" v-model="selectedWomenSize">
          </Multiselect>
        </div>
        <div>
          <strong class="block mb-2 uppercase">{{ $t('Velikost pánského prstenu') }}:</strong>
          <Multiselect :close-on-select="true" :canClear="false" :canDeselect="false" :options="menSizes" :placeholder="$t('vyberte...')" label="name" valueProp="id" v-model="selectedMenSize">
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" style="flex-wrap: wrap; gap: 10px; justify-content: space-between; flex: 1;">
                <span style="width: 30%;">{{ value.name }}</span><img v-if="tText" style="margin-left: auto; margin-right: auto;" :src="appConfig.serviceTextRenderUrl.replace('{0}', value.id).replace('{1}', tText)" />
              </div>
            </template>
            <template v-slot:option="{ option }">
              <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px; justify-content: space-between; flex: 1;">
                <span style="width: 30%;">{{ option.name }}</span><img v-if="tText" style="margin-left: auto; margin-right: auto;" :src="appConfig.serviceTextRenderUrl.replace('{0}', option.id).replace('{1}', tText)" />
              </div>
            </template>
          </Multiselect>
        </div>
      </div>
      <AtomsGlobalLink :to="appConfig.definedPageUrls.sizeHelper" target="_blank" class="block my-4 font-bold text-secondary">{{ $t('Jak vybrat tu správnou?') }}</AtomsGlobalLink>
      <div class="flex flex-wrap gap-6 my-8">
        <MoleculesBlocksFilterItem class="w-full lg:flex-1" :label="$t('Materiál prstenů?')" :options="materialOptions" :show-all-options-default="true" @apply-filter="(...args) => setOption(materialOptions, ...args)" />
        <MoleculesBlocksFilterItem class="w-full lg:flex-1" :label="$t('Cena za pár?')" :single-option-only="true" :options="priceOptions" :show-all-options-default="true" @apply-filter="(...args) => setOption(priceOptions, ...args)" />
        <MoleculesBlocksFilterItem class="w-full lg:flex-1" :label="$t('Kdy nejpozději snubní prsteny potřebujete?')" :single-option-only="true" :options="deliveryPeriodOptions" :show-all-options-default="true" @apply-filter="(...args) => setOption(deliveryPeriodOptions, ...args)" />
      </div>
      <div class="flex flex-wrap lg:flex-nowrap gap-6 lg:justify-between">
        <div class="flex-1 min-w-[400px] max-w-[700px] text-gray"><strong class="block">{{ $t('Pozn:') }}</strong>
          {{ $t('Ve vybrané lhůtě není uvažováno rytí do prstenů, které prodlouží dobu dodání prstenů až o 1 týden. Pokud tedy potřebujete mít prsteny například do 14 dnů a chcete si do nich nechat něco vyrýt, vyberte si dostupnost prstenů "Do týdne". Pokud zvolíte možnost "Co nejdříve", nabídneme vám pouze prsteny, které máme skladem.') }}
        </div>
        <div>
          <MoleculesButtonsButton :arrow-right="true" @click="find">{{ $t('Najděte nám naše vysněné prsteny') }}</MoleculesButtonsButton>
        </div>
      </div>
      <div v-if="totalItems" id="configuratorResults">
        <OrganismsListsWareList :items="items" :with-sorting="true" items-link-target="_blank" :page-size="appConfig.wareList.itemsOnPage" :page="page" :total-items="totalItems" list-name="Konfigurátor" />
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>

import Multiselect from '@vueform/multiselect';
import "assets/css/multiselect.css";

const appConfig = useAppConfig();
const locale = useLocale().getLocale();
const i18n = useI18n();

const items = ref([]);
const page = ref(1);
const totalItems = ref(0);

const materialOptions = ref([]);

const parameterOptions = (await useApiFetch(`/api/configuratorProperties?languageId=${locale.languageId}`)).data.value.custom.jb.configuratorProperties;

const womenSizes = parameterOptions.womenSizes.sort((a, b) => parseInt(a.value) - parseInt(b.value)).map(item => {
  return {
    id: item.lValue,
    name: item.value
  }
});

const menSizes = parameterOptions.menSizes.sort((a, b) => parseInt(a.value) - parseInt(b.value)).map(item => {
  return {
    id: item.lValue,
    name: item.value
  }
});

materialOptions.value = parameterOptions.materials.sort((a, b) => a.value - b.value).map(item => {
  return {
    text: useUtils().capitalize(item.value),
    urlValue: item.lValue
  };
});

materialOptions.value.push({
  text: i18n.t('Je nám to jedno'),
  urlValue: '',
  selected: true
});

const priceOptions = ref([
  {
    text: i18n.t('Do 1 000 Kč'),
    urlValue: '1000'
  },
  {
    text: i18n.t('Do 2 000 Kč'),
    urlValue: '2000'
  },
  {
    text: i18n.t('Do 5 000 Kč'),
    urlValue: '5000'
  },
  {
    text: i18n.t('Do 10 000 Kč'),
    urlValue: '10000'
  },
  {
    text: i18n.t('Je nám to jedno'),
    urlValue: '',
    selected: true
  }
]);

const deliveryPeriodOptions = ref([
  {
    text: i18n.t('Co nejdříve'),
    urlValue: '0'
  },
  {
    text: i18n.t('Do týdne'),
    urlValue: '7'
  },
  {
    text: i18n.t('Do 2 týdnů'),
    urlValue: '14'
  },
  {
    text: i18n.t('Do měsíce'),
    urlValue: '28'
  },
  {
    text: i18n.t('Do 2 měsíců'),
    urlValue: '60'
  },
  {
    text: i18n.t('Je nám to jedno'),
    urlValue: '',
    selected: true
  }
]);

const selectedWomenSize = ref(0);
const selectedMenSize = ref(0);
const selectedMaterials = computed(() => materialOptions.value.filter(q => q.urlValue !== '' && (q.selected || materialOptions.value.find(qq => qq.urlValue === '').selected)).map(item => item.urlValue).join(','));
const selectedMaximalPrice = computed(() => priceOptions.value.find(q => q.selected)?.urlValue ?? '');
const selectedMaximalDeliveryPeriod = computed(() => deliveryPeriodOptions.value.find(q => q.selected)?.urlValue ?? '');

const setOption = (target, urlParameter, urlValue, remove, replace) => {
  if (remove) {
    target.find(q => q.urlValue === urlValue && q.selected).selected = false;

    // trying to uncheck last option - keep 
    if (replace) {

    }
  }
  else if (replace) {
    target.filter(q => q.selected).forEach(item => item.selected = false);
    target.find(q => q.urlValue === urlValue).selected = true;
  }
  else {
    target.find(q => q.urlValue === urlValue).selected = true;
  }

  if (urlValue === '') {
    nextTick(() => { target.forEach(item => item.selected = item.urlValue === '') });
  }
  else {
    target.find(q => q.urlValue === '').selected = false;
  }

  nextTick(() => {
    if (!target.find(q => q.selected)) {
      target.find(q => q.urlValue === '').selected = true;
    }
  });
}

const validate = () => selectedWomenSize.value && selectedMenSize.value && materialOptions.value.some(q => q.selected) && priceOptions.value.some(q => q.selected) && deliveryPeriodOptions.value.some(q => q.selected);

const find = async () => {
  page.value = 1;
  useRouter().push('');
  loadItems();
}

const loadItems = async () => {
  if (!validate()) {
    useMessage().show(i18n.t('Pro vyhledání je nutné vybrat ze všech kritérií'), null, true, false, i18n.t('Dobře'), 5);
    return;
  }

  const modifiedHashObj = useShopRouting().updateValueInHash('p', page.value, false, true);

  const queryUrl = `/api/configuratorResults?maximalDeliveryPeriod=${selectedMaximalDeliveryPeriod.value}&lValueSizeWomen=${selectedWomenSize.value}&lValueSizeMen=${selectedMenSize.value}&lValuesMaterial=${selectedMaterials.value}&maximalPrice=${selectedMaximalPrice.value}&currencyId=${locale.currencyId}&languageId=${locale.languageId}&${useShopRouting().stringifyHash(modifiedHashObj).replace('#!', '')}`;
  const result = (await useApiFetch(queryUrl)).data.value.custom.jb.configurator;

  items.value = result.items;
  totalItems.value = result.count;

  nextTick(() => {
    if (totalItems.value) {
      useUtils().scrollTo(document.getElementById('configuratorResults'));
    }
    else {
      useMessage().show(i18n.t('Nebyly nalezeny žádné výsledky, upravte prosím zadání ve filtru'), null, false, true, i18n.t('Dobře'), 3);
    }
  });
}

// reload items when the page hash changes
watch(() => useRoute().hash, async () => {

  const hash = useShopRouting().parseHash();
  page.value = parseInt(hash.find(q => q.key === 'p')?.value ?? "1");

  if (hash.length) {
    loadItems();
  }
});

</script>